<template>
  <p v-if="message" class="mt-2 hidden text-center text-sm text-red-400 sm:block">
    {{ message }}
  </p>
</template>

<script>
export default {
  name: "ErrorTooltip",
  props: {
    message: {
      type: String,
      default: "",
    },
  },
};
</script>
